import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const RouterLink = React.forwardRef(({ to, ...props }, ref) => {
	return <Link {...props} to={to} ref={ref} />;
});

RouterLink.propTypes = {
	to: PropTypes.string,
};

RouterLink.displayName = 'RouterLink';

export default RouterLink;
